// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/health/v1/health.proto" (package "agency.health.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { HealthStatus } from "../../registry/v1/registry";
/**
 * HealthProbeConfig configures health probe endpoints.
 *
 * @generated from protobuf message agency.health.v1.HealthProbeConfig
 */
export interface HealthProbeConfig {
    /**
     * enabled indicates if health probes are enabled.
     *
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * bind_addr is the health probe server bind address.
     *
     * @generated from protobuf field: string bind_addr = 2
     */
    bindAddr: string;
    /**
     * readiness_path is the readiness probe HTTP path.
     *
     * @generated from protobuf field: string readiness_path = 3
     */
    readinessPath: string;
    /**
     * liveness_path is the liveness probe HTTP path.
     *
     * @generated from protobuf field: string liveness_path = 4
     */
    livenessPath: string;
    /**
     * startup_path is the startup probe HTTP path.
     *
     * @generated from protobuf field: string startup_path = 5
     */
    startupPath: string;
}
/**
 * HealthCheckRequest requests health status.
 *
 * @generated from protobuf message agency.health.v1.HealthCheckRequest
 */
export interface HealthCheckRequest {
    /**
     * component filters by specific component (empty = all).
     *
     * @generated from protobuf field: string component = 1
     */
    component: string;
    /**
     * include_details includes detailed component status.
     *
     * @generated from protobuf field: bool include_details = 2
     */
    includeDetails: boolean;
}
/**
 * HealthCheckResponse returns health status.
 *
 * @generated from protobuf message agency.health.v1.HealthCheckResponse
 */
export interface HealthCheckResponse {
    /**
     * overall_status is the overall health status.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus overall_status = 1
     */
    overallStatus: HealthStatus;
    /**
     * components are individual component statuses.
     *
     * @generated from protobuf field: repeated agency.health.v1.ComponentStatus components = 2
     */
    components: ComponentStatus[];
    /**
     * checked_at is when the health check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 3
     */
    checkedAt?: Timestamp;
    /**
     * message provides additional context.
     *
     * @generated from protobuf field: string message = 4
     */
    message: string;
}
/**
 * ComponentStatus represents a single component's health.
 *
 * @generated from protobuf message agency.health.v1.ComponentStatus
 */
export interface ComponentStatus {
    /**
     * component_name identifies the component.
     *
     * @generated from protobuf field: string component_name = 1
     */
    componentName: string;
    /**
     * status is the component health status.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus status = 2
     */
    status: HealthStatus;
    /**
     * message provides status details.
     *
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * last_check_at is when this component was last checked.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_check_at = 4
     */
    lastCheckAt?: Timestamp;
    /**
     * metrics contains component-specific metrics.
     *
     * @generated from protobuf field: map<string, double> metrics = 5
     */
    metrics: {
        [key: string]: number;
    };
    /**
     * error_count is the number of recent errors.
     *
     * @generated from protobuf field: uint64 error_count = 6
     */
    errorCount: bigint;
}
/**
 * ReadinessCheckRequest requests readiness status.
 *
 * @generated from protobuf message agency.health.v1.ReadinessCheckRequest
 */
export interface ReadinessCheckRequest {
    /**
     * component filters by specific component (empty = all).
     *
     * @generated from protobuf field: string component = 1
     */
    component: string;
}
/**
 * ReadinessCheckResponse returns readiness status.
 *
 * @generated from protobuf message agency.health.v1.ReadinessCheckResponse
 */
export interface ReadinessCheckResponse {
    /**
     * ready indicates if the system is ready to serve traffic.
     *
     * @generated from protobuf field: bool ready = 1
     */
    ready: boolean;
    /**
     * components are individual component readiness statuses.
     *
     * @generated from protobuf field: repeated agency.health.v1.ComponentReadiness components = 2
     */
    components: ComponentReadiness[];
    /**
     * checked_at is when the readiness check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 3
     */
    checkedAt?: Timestamp;
    /**
     * message provides additional context.
     *
     * @generated from protobuf field: string message = 4
     */
    message: string;
}
/**
 * ComponentReadiness represents a component's readiness.
 *
 * @generated from protobuf message agency.health.v1.ComponentReadiness
 */
export interface ComponentReadiness {
    /**
     * component_name identifies the component.
     *
     * @generated from protobuf field: string component_name = 1
     */
    componentName: string;
    /**
     * ready indicates if the component is ready.
     *
     * @generated from protobuf field: bool ready = 2
     */
    ready: boolean;
    /**
     * message provides readiness details.
     *
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * last_check_at is when this component was last checked.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_check_at = 4
     */
    lastCheckAt?: Timestamp;
}
/**
 * LivenessCheckRequest requests liveness status.
 *
 * @generated from protobuf message agency.health.v1.LivenessCheckRequest
 */
export interface LivenessCheckRequest {
    /**
     * component filters by specific component (empty = all).
     *
     * @generated from protobuf field: string component = 1
     */
    component: string;
}
/**
 * LivenessCheckResponse returns liveness status.
 *
 * @generated from protobuf message agency.health.v1.LivenessCheckResponse
 */
export interface LivenessCheckResponse {
    /**
     * alive indicates if the system is alive.
     *
     * @generated from protobuf field: bool alive = 1
     */
    alive: boolean;
    /**
     * components are individual component liveness statuses.
     *
     * @generated from protobuf field: repeated agency.health.v1.ComponentLiveness components = 2
     */
    components: ComponentLiveness[];
    /**
     * checked_at is when the liveness check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 3
     */
    checkedAt?: Timestamp;
    /**
     * message provides additional context.
     *
     * @generated from protobuf field: string message = 4
     */
    message: string;
}
/**
 * ComponentLiveness represents a component's liveness.
 *
 * @generated from protobuf message agency.health.v1.ComponentLiveness
 */
export interface ComponentLiveness {
    /**
     * component_name identifies the component.
     *
     * @generated from protobuf field: string component_name = 1
     */
    componentName: string;
    /**
     * alive indicates if the component is alive.
     *
     * @generated from protobuf field: bool alive = 2
     */
    alive: boolean;
    /**
     * message provides liveness details.
     *
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * last_check_at is when this component was last checked.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_check_at = 4
     */
    lastCheckAt?: Timestamp;
    /**
     * last_success_at is when this component last succeeded.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_success_at = 5
     */
    lastSuccessAt?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class HealthProbeConfig$Type extends MessageType<HealthProbeConfig> {
    constructor() {
        super("agency.health.v1.HealthProbeConfig", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "bind_addr", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "readiness_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^/[a-z0-9/_-]*$" } } } },
            { no: 4, name: "liveness_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^/[a-z0-9/_-]*$" } } } },
            { no: 5, name: "startup_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^/[a-z0-9/_-]*$" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthProbeConfig>): HealthProbeConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.bindAddr = "";
        message.readinessPath = "";
        message.livenessPath = "";
        message.startupPath = "";
        if (value !== undefined)
            reflectionMergePartial<HealthProbeConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthProbeConfig): HealthProbeConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string bind_addr */ 2:
                    message.bindAddr = reader.string();
                    break;
                case /* string readiness_path */ 3:
                    message.readinessPath = reader.string();
                    break;
                case /* string liveness_path */ 4:
                    message.livenessPath = reader.string();
                    break;
                case /* string startup_path */ 5:
                    message.startupPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthProbeConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string bind_addr = 2; */
        if (message.bindAddr !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.bindAddr);
        /* string readiness_path = 3; */
        if (message.readinessPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.readinessPath);
        /* string liveness_path = 4; */
        if (message.livenessPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.livenessPath);
        /* string startup_path = 5; */
        if (message.startupPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.startupPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.HealthProbeConfig
 */
export const HealthProbeConfig = new HealthProbeConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckRequest$Type extends MessageType<HealthCheckRequest> {
    constructor() {
        super("agency.health.v1.HealthCheckRequest", [
            { no: 1, name: "component", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } },
            { no: 2, name: "include_details", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<HealthCheckRequest>): HealthCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.component = "";
        message.includeDetails = false;
        if (value !== undefined)
            reflectionMergePartial<HealthCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckRequest): HealthCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component */ 1:
                    message.component = reader.string();
                    break;
                case /* bool include_details */ 2:
                    message.includeDetails = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component = 1; */
        if (message.component !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.component);
        /* bool include_details = 2; */
        if (message.includeDetails !== false)
            writer.tag(2, WireType.Varint).bool(message.includeDetails);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.HealthCheckRequest
 */
export const HealthCheckRequest = new HealthCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckResponse$Type extends MessageType<HealthCheckResponse> {
    constructor() {
        super("agency.health.v1.HealthCheckResponse", [
            { no: 1, name: "overall_status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComponentStatus, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 3, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthCheckResponse>): HealthCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.overallStatus = 0;
        message.components = [];
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<HealthCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckResponse): HealthCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.registry.v1.HealthStatus overall_status */ 1:
                    message.overallStatus = reader.int32();
                    break;
                case /* repeated agency.health.v1.ComponentStatus components */ 2:
                    message.components.push(ComponentStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp checked_at */ 3:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.registry.v1.HealthStatus overall_status = 1; */
        if (message.overallStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.overallStatus);
        /* repeated agency.health.v1.ComponentStatus components = 2; */
        for (let i = 0; i < message.components.length; i++)
            ComponentStatus.internalBinaryWrite(message.components[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp checked_at = 3; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.HealthCheckResponse
 */
export const HealthCheckResponse = new HealthCheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComponentStatus$Type extends MessageType<ComponentStatus> {
    constructor() {
        super("agency.health.v1.ComponentStatus", [
            { no: 1, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 4, name: "last_check_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "metrics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } } } } } },
            { no: 6, name: "error_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<ComponentStatus>): ComponentStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.componentName = "";
        message.status = 0;
        message.message = "";
        message.metrics = {};
        message.errorCount = 0n;
        if (value !== undefined)
            reflectionMergePartial<ComponentStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComponentStatus): ComponentStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component_name */ 1:
                    message.componentName = reader.string();
                    break;
                case /* agency.registry.v1.HealthStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_check_at */ 4:
                    message.lastCheckAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastCheckAt);
                    break;
                case /* map<string, double> metrics */ 5:
                    this.binaryReadMap5(message.metrics, reader, options);
                    break;
                case /* uint64 error_count */ 6:
                    message.errorCount = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: ComponentStatus["metrics"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ComponentStatus["metrics"] | undefined, val: ComponentStatus["metrics"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.double();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.health.v1.ComponentStatus.metrics");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: ComponentStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component_name = 1; */
        if (message.componentName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.componentName);
        /* agency.registry.v1.HealthStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* google.protobuf.Timestamp last_check_at = 4; */
        if (message.lastCheckAt)
            Timestamp.internalBinaryWrite(message.lastCheckAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, double> metrics = 5; */
        for (let k of globalThis.Object.keys(message.metrics))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Bit64).double(message.metrics[k]).join();
        /* uint64 error_count = 6; */
        if (message.errorCount !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.errorCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.ComponentStatus
 */
export const ComponentStatus = new ComponentStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadinessCheckRequest$Type extends MessageType<ReadinessCheckRequest> {
    constructor() {
        super("agency.health.v1.ReadinessCheckRequest", [
            { no: 1, name: "component", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ReadinessCheckRequest>): ReadinessCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.component = "";
        if (value !== undefined)
            reflectionMergePartial<ReadinessCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReadinessCheckRequest): ReadinessCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component */ 1:
                    message.component = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReadinessCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component = 1; */
        if (message.component !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.component);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.ReadinessCheckRequest
 */
export const ReadinessCheckRequest = new ReadinessCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadinessCheckResponse$Type extends MessageType<ReadinessCheckResponse> {
    constructor() {
        super("agency.health.v1.ReadinessCheckResponse", [
            { no: 1, name: "ready", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComponentReadiness, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 3, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<ReadinessCheckResponse>): ReadinessCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ready = false;
        message.components = [];
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<ReadinessCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReadinessCheckResponse): ReadinessCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool ready */ 1:
                    message.ready = reader.bool();
                    break;
                case /* repeated agency.health.v1.ComponentReadiness components */ 2:
                    message.components.push(ComponentReadiness.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp checked_at */ 3:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReadinessCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool ready = 1; */
        if (message.ready !== false)
            writer.tag(1, WireType.Varint).bool(message.ready);
        /* repeated agency.health.v1.ComponentReadiness components = 2; */
        for (let i = 0; i < message.components.length; i++)
            ComponentReadiness.internalBinaryWrite(message.components[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp checked_at = 3; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.ReadinessCheckResponse
 */
export const ReadinessCheckResponse = new ReadinessCheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComponentReadiness$Type extends MessageType<ComponentReadiness> {
    constructor() {
        super("agency.health.v1.ComponentReadiness", [
            { no: 1, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "ready", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 4, name: "last_check_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ComponentReadiness>): ComponentReadiness {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.componentName = "";
        message.ready = false;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<ComponentReadiness>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComponentReadiness): ComponentReadiness {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component_name */ 1:
                    message.componentName = reader.string();
                    break;
                case /* bool ready */ 2:
                    message.ready = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_check_at */ 4:
                    message.lastCheckAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastCheckAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComponentReadiness, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component_name = 1; */
        if (message.componentName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.componentName);
        /* bool ready = 2; */
        if (message.ready !== false)
            writer.tag(2, WireType.Varint).bool(message.ready);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* google.protobuf.Timestamp last_check_at = 4; */
        if (message.lastCheckAt)
            Timestamp.internalBinaryWrite(message.lastCheckAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.ComponentReadiness
 */
export const ComponentReadiness = new ComponentReadiness$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LivenessCheckRequest$Type extends MessageType<LivenessCheckRequest> {
    constructor() {
        super("agency.health.v1.LivenessCheckRequest", [
            { no: 1, name: "component", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<LivenessCheckRequest>): LivenessCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.component = "";
        if (value !== undefined)
            reflectionMergePartial<LivenessCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LivenessCheckRequest): LivenessCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component */ 1:
                    message.component = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LivenessCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component = 1; */
        if (message.component !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.component);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.LivenessCheckRequest
 */
export const LivenessCheckRequest = new LivenessCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LivenessCheckResponse$Type extends MessageType<LivenessCheckResponse> {
    constructor() {
        super("agency.health.v1.LivenessCheckResponse", [
            { no: 1, name: "alive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComponentLiveness, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 3, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<LivenessCheckResponse>): LivenessCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alive = false;
        message.components = [];
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<LivenessCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LivenessCheckResponse): LivenessCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool alive */ 1:
                    message.alive = reader.bool();
                    break;
                case /* repeated agency.health.v1.ComponentLiveness components */ 2:
                    message.components.push(ComponentLiveness.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp checked_at */ 3:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LivenessCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool alive = 1; */
        if (message.alive !== false)
            writer.tag(1, WireType.Varint).bool(message.alive);
        /* repeated agency.health.v1.ComponentLiveness components = 2; */
        for (let i = 0; i < message.components.length; i++)
            ComponentLiveness.internalBinaryWrite(message.components[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp checked_at = 3; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.LivenessCheckResponse
 */
export const LivenessCheckResponse = new LivenessCheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComponentLiveness$Type extends MessageType<ComponentLiveness> {
    constructor() {
        super("agency.health.v1.ComponentLiveness", [
            { no: 1, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "alive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 4, name: "last_check_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "last_success_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ComponentLiveness>): ComponentLiveness {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.componentName = "";
        message.alive = false;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<ComponentLiveness>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComponentLiveness): ComponentLiveness {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string component_name */ 1:
                    message.componentName = reader.string();
                    break;
                case /* bool alive */ 2:
                    message.alive = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_check_at */ 4:
                    message.lastCheckAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastCheckAt);
                    break;
                case /* google.protobuf.Timestamp last_success_at */ 5:
                    message.lastSuccessAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSuccessAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComponentLiveness, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string component_name = 1; */
        if (message.componentName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.componentName);
        /* bool alive = 2; */
        if (message.alive !== false)
            writer.tag(2, WireType.Varint).bool(message.alive);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* google.protobuf.Timestamp last_check_at = 4; */
        if (message.lastCheckAt)
            Timestamp.internalBinaryWrite(message.lastCheckAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_success_at = 5; */
        if (message.lastSuccessAt)
            Timestamp.internalBinaryWrite(message.lastSuccessAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.health.v1.ComponentLiveness
 */
export const ComponentLiveness = new ComponentLiveness$Type();
